import React from 'react';
import { Button, Form, Grid, Header, Icon, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import Label from 'react-bootstrap/lib/Label';
import { HeaderCursor } from '../Professor/ProfessorInputGrades/css';
import { Redirect } from 'react-router-dom';
import { ExportReactCSV } from '../util/ExportCSV';
import moment from 'moment';
import ReactExport from 'react-data-export';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class StudentFilterEmploymentServiceCS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            jmbg: '',
            student: null,

            students: [],
            studentsForExcel: [],

            loading: false,
            loader: true,
            open: false,
            cli: false,
            first: false,
            academicYear: JSON.parse(localStorage.getItem('academicYear')).name,
            academicYearId: JSON.parse(localStorage.getItem('academicYear')).id,
            showStudentInfo: false
        };

        this.showStudents = this.showStudents.bind(this);
        this.getStudents = this.getStudents.bind(this);
    }

    getStudents() {
        const {
            firstName, lastName, jmbg, clicked
        } = this.state;
        this.setState({ clicked: true, students: [] });
        let docFilter = {};

        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (jmbg) docFilter = { ...docFilter, jmbg };

        axios.post(`students/enrollment-information-for-employment-service/${this.state.academicYearId}`, { ...docFilter })
            .then(res => {
                const students = res.data.map(el => ({
                    ...el,
                    dateOfBirth: el.dateOfBirth ? moment(el.dateOfBirth).format('D. M. YYYY.') : '',
                    dateOfAbandonment: el.dateOfAbandonment ? moment(el.dateOfAbandonment).format('D. M. YYYY.') : '',
                    studyTypeName: el.studyProgramSemesterName === 'Apsolventski staž' ? el.gradAcademicYearStudyTypeName : el.studyTypeName,
                    graduationDate: el.graduationDate ? moment(el.graduationDate).format('D. M. YYYY.') : '',
                    sspsLastUpdated: el.sspsLastUpdated ? moment(el.sspsLastUpdated).format('D. M. YYYY.') : '',
                }));
                const excelData = res.data.map(el => ([
                    { value: el.firstName },
                    { value: el.lastName },
                    { value: el.fatherName ? el.fatherName : '' },
                    { value: el.dateOfBirth ? moment(el.dateOfBirth).format('D. M. YYYY.') : '' },
                    { value: el.organizationalUnitName ? el.organizationalUnitName : '' },
                    { value: el.departments[0].name ? el.departments[0].name : '' },
                    { value: el.studyProgramBasicName ? el.studyProgramBasicName : '' },
                    { value: el.studyCycleName ? el.studyCycleName : '' },
                    { value: el.academicYearName ? el.academicYearName : '' },
                    { value: el.studyProgramSemesterName ? el.studyProgramSemesterName : '' },
                    { value: el.studyProgramSemesterName === 'Apsolventski staž' ? el.gradAcademicYearStudyTypeName : el.studyTypeName },
                    { value: el.sspsLastUpdated ? moment(el.sspsLastUpdated).format('D. M. YYYY.') : '' },
                    { value: el.dateOfAbandonment ? moment(el.dateOfAbandonment).format('D. M. YYYY.') : '' },
                    { value: el.graduationDate ? moment(el.graduationDate).format('D. M. YYYY.') : '' },

                ]));
                this.setState({ students, excelData });
                this.setState({ loader: false });
            })
            .catch(err => {
                console.log('Failed to fetch students');
            });
    }

    showStudents() {
        const { firstName, lastName, jmbg } = this.state;
        if (!firstName && !lastName && !jmbg) {
            toast('Morate unijeti JMBG ili ime i prezime studenta/ice.');
        } else if (firstName && !lastName && !jmbg) {
            toast('Morate unijeti JMBG ili ime i prezime studenta/ice.');
        } else if (!firstName && lastName && !jmbg) {
            toast('Morate unijeti JMBG ili ime i prezime studenta/ice.');
        } else {
            this.setState({ loading: true });

            let docFilter = {};

            if (firstName) docFilter = { ...docFilter, firstName };
            if (lastName) docFilter = { ...docFilter, lastName };
            if (jmbg) docFilter = { ...docFilter, jmbg };
            axios.post(`students/enrollment-information-for-employment-service/${this.state.academicYearId}`, { ...docFilter })
                .then(res => {
                    this.setState({ students: res.data, open: true, loading: false });
                })
                .catch(err => {
                    console.log('Failed to fetch students');
                });
        }
        this.setState({ first: true });
    }

    render() {
        if (this.state.showStudentInfo) return <Redirect push to={{ pathname: '/pretraga-studenata/informacije-o-studentu' }} />;
        // const headersForExport = [
        //     { label: 'Ime', key: 'firstName' },
        //     { label: 'Prezime', key: 'lastName' },
        //     { label: 'Ime oca', key: 'fatherName' },
        //     { label: 'Datum rođenja', key: 'dateOfBirth' },
        //     { label: 'Organizaciona jedinica', key: 'organizationalUnitName' },
        //     { label: 'Odsjek', key: 'departments[0].name' },
        //     { label: 'Studijski program', key: 'studyProgramBasicName' },
        //     { label: 'Ciklus studija', key: 'studyCycleName' },
        //     { label: 'Akademska godina', key: 'academicYearName' },
        //     { label: 'Semestar', key: 'studyProgramSemesterName' },
        //     { label: 'Tip studiranja', key: 'studyTypeName' },
        //     { label: 'Datum zadnje izmjene upisa u semestar/apsolventski staž', key: 'sspsLastUpdated' },
        //     { label: 'Datum ispisa', key: 'dateOfAbandonment' },
        //     { label: 'Datum diplomiranja', key: 'graduationDate' },
        // ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Ime', width: { wpx: 200 } },
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Ime oca', width: { wpx: 150 } },
                    { title: 'Datum rođenja', width: { wpx: 150 } },
                    { title: 'Organizaciona jedinica', width: { wpx: 400 } },
                    { title: 'Odsjek', width: { wpx: 350 } },
                    { title: 'Studijski program', width: { wpx: 350 } },
                    { title: 'Ciklus studija', width: { wpx: 350 } },
                    { title: 'Akademska godina', width: { wpx: 150 } },
                    { title: 'Semestar', width: { wpx: 150 } },
                    { title: 'Tip studiranja', width: { wpx: 200 } },
                    { title: 'Datum zadnje izmjene upisa u semestar/apsolventski staž', width: { wpx: 350 } },
                    { title: 'Datum ispisa', width: { wpx: 150 } },
                    { title: 'Datum diplomiranja', width: { wpx: 150 } },

                ],
                data: this.state.excelData,
            }
        ];
        return (
            <div >
                <h1>Pretraga studenata</h1>
                <Segment.Group raised>
                    <Segment>
                        <Grid columns={2} stackable verticalAlign="middle">
                            <Grid.Column width={13}>
                                <Header as="h3" verticalAlign="middle">Studenti
                                    <Header.Subheader as="h6" color="grey">
                                        Pretraživati se mogu samo studenti upisani u tekuću, odnosno {this.state.academicYear}. akademsku godinu.
                                    </Header.Subheader>
                                </Header>
                            </Grid.Column>
                            <Grid.Column width={3}>

                                {(!this.state.clicked && this.state.loader && !this.state.first) && <Button
                                    basic
                                    fluid
                                    color="green"
                                    size="small"
                                    onClick={this.getStudents}
                                >
                                    <Button.Content hidden></Button.Content>
                                    <Button.Content visible>
                                        Preuzmi spisak u Excel-u
                                    </Button.Content>
                                </Button>}
                                {(this.state.clicked && this.state.loader) && <Button
                                    basic
                                    fluid
                                    size="small"
                                    color="red"
                                    disabled
                                >
                                    <Button.Content hidden></Button.Content>
                                    <Button.Content visible>
                                        <Loader active size="mini" />
                                        Pripremanje spiska
                                    </Button.Content>
                                </Button>}

                                {(!this.state.loader && !this.state.first) &&
                                <ExcelFile
                                    filename="Spisak studenata upisanih u trenutnu akademsku godinu"
                                    element={<Popup
                                        trigger={<Button animated="vertical" color="green" basic floated="right" fluid style={{ textAlign: 'center' }}>
                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                            <Button.Content visible>
                                                Excel
                                            </Button.Content>
                                        </Button>}
                                        content="Preuzmi spisak u Excel-u"
                                        hideOnScroll
                                        position="top center"
                                    />}
                                >
                                    <ExcelSheet dataSet={multiDataSet} name="Spisak studenata upisanih u trenutnu akademsku godinu" />
                                </ExcelFile>
                                // <ExportReactCSV
                                //     color="green"
                                //     fluid
                                //     employmentservicecs
                                //     csvData={this.state.students}
                                //     headers={headersForExport}
                                //     fileName="Spisak studenata upisanih u trenutnu akademsku godinu"
                                // />
                                }
                            </Grid.Column>
                        </Grid>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Ime</label>
                                    <input
                                        value={this.state.firstName}
                                        onChange={(e) => this.setState({ firstName: e.target.value })}
                                        name="firstName"
                                        placeholder="Unesite ime"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Prezime</label>
                                    <input
                                        value={this.state.lastName}
                                        onChange={(e) => this.setState({ lastName: e.target.value })}
                                        name="lastName"
                                        placeholder="Unesite prezime"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>JMBG</label>
                                    <input
                                        value={this.state.jmbg}
                                        onChange={(e) => this.setState({ jmbg: e.target.value })}
                                        name="jmbg"
                                        placeholder="Unesite jmbg"
                                    />
                                </Form.Field>
                            </Form.Group>

                            <Button floated="right" color="blue" onClick={this.showStudents}>Prikaži studente</Button>
                        </Form>
                        <br />

                        <ToastContainer hideProgressBar />

                        {(this.state.open || this.state.loading) &&
                        <div>
                            <br />
                            {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                                : this.state.students.length ?
                                    <Table celled selectable compact >
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell width="2">JMBG</Table.HeaderCell>
                                                <Table.HeaderCell>Prezime (ime oca) ime</Table.HeaderCell>
                                                <Table.HeaderCell>Organizaciona jedinica</Table.HeaderCell>
                                                <Table.HeaderCell width="3">Semestar (akademska godina)</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body> {this.state.students.map((el, index) =>
                                            (<Popup
                                                trigger={<Table.Row
                                                    key={index}
                                                    style={HeaderCursor}
                                                    onClick={() => {
                                                        this.setState({ student: el, showStudentInfo: true });
                                                        localStorage.setItem('student', JSON.stringify(el));
                                                    }}
                                                >
                                                    <Table.Cell verticalAlign="middle" width={2}>
                                                        {el.jmbg}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.lastName} ({el.fatherName ? el.fatherName : ''}) {el.firstName}
                                                        {el.locked === 1 ? <Popup content="Student/ica je zaključan/a." hideOnScroll position="top center" trigger={<Label size="tiny" as="a" basic><span style={{ float: 'right' }}> <Icon name="lock" color="blue" /></span></Label>} /> : null}
                                                        {el.switchedToNewStudyProgram ? <Popup content="Student/ica je prešao/la na inovirani nastavni plan." hideOnScroll position="top center" trigger={<Label size="tiny" as="a" basic><span style={{ float: 'right' }}> <Icon name="exchange" color="blue" /></span></Label>} /> : null}
                                                        {el.dateOfAbandonment !== null ? <Popup content="Student/ica je ispisan/a." hideOnScroll position="top center" trigger={<Label size="tiny" as="a" basic><span style={{ float: 'right' }}> <Icon name="sign-out" color="red" /></span></Label>} /> : null}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                        {el.organizationalUnitName}
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle" width="3">
                                                        {el.semesterName} ({el.academicYearName})
                                                    </Table.Cell>
                                                </Table.Row>}
                                                content="Prikaz informacija o studentu"
                                                hideOnScroll
                                                position="left center"
                                            />))}
                                        </Table.Body>
                                    </Table>
                                    : 'Nema studenata.' }
                        </div>}
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/EmploymentServiceCS/StudentFilterEmploymentServiceCS.js